import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from "react-redux";
import CollapsibleContainer from '../components/collapsibleContainer';
import { HeightSlider } from "./twoD";
import { TbBoxModel } from "react-icons/tb";
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { ACTIONS as DATA_ACTIONS } from "../redux/reducers/DataReducer"

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';




const ThreeScene = ({ tex, width, height }) => {
    const mountRef = useRef(null);
    const sphereMaterialRef = useRef(null);
    const [cursorCoordinates, setCursorCoordinates] = useState(null)
    const dispatch = useDispatch();

    useEffect(() => {
      // Scene
      const scene = new THREE.Scene();
  
      // Camera
      const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000);
      camera.position.z = 5;
  
      // Renderer
      const renderer = new THREE.WebGLRenderer({ antialias: false , alpha: true});
      renderer.setSize(width, height);
      renderer.setClearColor(0x000000, 0); // Set clear color to black with 0 opacity


      //    cursor
        const cursor = new THREE.Mesh(new THREE.SphereGeometry(0.1,5,5),
        new THREE.MeshBasicMaterial({color:0xff0000}) );
        cursor.position.copy( {x: 0, y:0, z:0});
        scene.add( cursor ); 

  
      // Sphere with texture
      const geometry = new THREE.SphereGeometry(2, 32, 32);
      
      const material = new THREE.MeshBasicMaterial({ map: tex });
      sphereMaterialRef.current = material; // Store material reference for updating texture
      const sphere = new THREE.Mesh(geometry, material);
      scene.add(sphere);

      // After renderer initialization
      const composer = new EffectComposer(renderer);
      composer.addPass(new RenderPass(scene, camera));

      // Outline pass
      const outlinePass = new OutlinePass(new THREE.Vector2(width, height), scene, camera);
      outlinePass.edgeStrength = 7;
      outlinePass.edgeGlow = .2;
      outlinePass.edgeThickness = 8.5;
      outlinePass.pulsePeriod = 10;
      outlinePass.visibleEdgeColor.set('white');
      outlinePass.hiddenEdgeColor.set('blue');
      composer.addPass(outlinePass);

      
 
      

      // FXAA pass
      const effectFXAA = new ShaderPass(FXAAShader);
      effectFXAA.uniforms['resolution'].value.set(1 / width, 1 / height);
      composer.addPass(effectFXAA);

      outlinePass.selectedObjects = [sphere];

  
      // Controls
      const controls = new OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true;
      controls.dampingFactor = 0.05;
      controls.enableZoom = true;

      // Add Raycasting
    const raycaster = new THREE.Raycaster();
    const mouse = new THREE.Vector2();

    function onMouseClick(event) {
      const rect = renderer.domElement.getBoundingClientRect();

      // Calculate mouse position in normalized device coordinates (-1 to +1) for both axes,
      // taking into account the bounding rectangle of the renderer element
      mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      mouse.y = - ((event.clientY - rect.top) / rect.height) * 2 + 1;

      // Update the picking ray with the camera and mouse position
      raycaster.setFromCamera(mouse, camera);

      // Calculate objects intersecting the picking ray
      const intersects = raycaster.intersectObject(sphere);

      if (intersects.length > 0) {
        const intersect = intersects[0];
        // console.log('Intersect point:', intersect.point);

        cursor.position.copy( intersects[ 0 ].point );

        const reducenumber = (n)=>n.toFixed(3);

        const coordinates = {
          x:  reducenumber(intersect.uv.x),
          y: reducenumber(intersect.uv.y)
        }

        setCursorCoordinates(coordinates)

        // use UV of the intersection
        dispatch({type: DATA_ACTIONS.SET_COORDINATES, coordinates: {x: coordinates.x, y: (1-coordinates.y).toFixed(3)}})

        }
      }
    

    // // Add event listener for mouse clicks
    window.addEventListener('click', onMouseClick);

  
      // Add renderer to the DOM
      mountRef.current.appendChild(renderer.domElement);
  
      // Animation loop
      const animate = () => {
        requestAnimationFrame(animate);
        controls.update();
        // renderer.render(scene, camera);
        composer.render();

      };
  
      // Start animation
      animate();
  
      // Cleanup
      return () => {
        mountRef.current.removeChild(renderer.domElement);
        scene.remove(sphere);
        geometry.dispose();
        material.dispose();
      };
    }, []); // Empty dependency array means this effect runs only once
  
    useEffect(() => {
      // Update texture if tex changes
      if (sphereMaterialRef.current) {
        sphereMaterialRef.current.map = tex;
        sphereMaterialRef.current.needsUpdate = true;
      }
    }, [tex]); // This effect runs when tex changes
  
    return <div ref={mountRef} style={{ width: '100%', height: '100%' }} />;
  };
  
  

const ThreeD = ({texture}) => {
    const [width, setWidth] = useState(0);
    const elementRef = useRef(null);
    const poi = useSelector(state=>state.data.poi);
    
  
    useEffect(() => {
      const observer = new ResizeObserver(entries => {
        for (let entry of entries) {
          const {width} = entry.contentRect;
          setWidth(width - 48); // Adjust the width as necessary
        }
      });
  
      if (elementRef.current) {
        observer.observe(elementRef.current);
      }
  
      // Cleanup
      return () => observer.disconnect();
    }, []); // Dependencies array is empty, meaning this effect runs once on mount
  
    
      return (
        <div ref={elementRef} style={{width: "100%", height: "100%"}}>
          <CollapsibleContainer open title="3D Map" icon={<TbBoxModel />}>
            {width > 0 && (
              <div>
                <HeightSlider />
    
                {texture ? <ThreeScene tex={texture} width={width} height={width}  /> : null}
                
              </div>
            )}
          </CollapsibleContainer>
        </div>
      );
    
  
    
  };
  
  
  export default ThreeD;